import React from 'react'
import { DashboardDefaultContainer } from '../../dashboard-default-container'
import Header from '../Header';
import EmployeeRegisterForm from './employee-register-form';

const EmployeeRegistration = () => {
  return (
    <DashboardDefaultContainer>
      <Header title='Employee Registration' href='/hr'/>
      <div>
        <EmployeeRegisterForm/>
      </div>
    </DashboardDefaultContainer>
  );
}

export default EmployeeRegistration